<template>
  <div>
    <div class="mdl-grid mdl-grid--no-spacing">
      <!-- <div class="mdl-cell mdl-cell--2-col"></div> -->
      <div class="mdl-cell mdl-cell--12-col mdl-card">
          <div class="mdl-card__title mdl-color--grey-100 mdl-color-text--grey-600">
            <div class="mdl-layout-spacer"></div>
            <h2 class="mdl-card__title-text">Amount : {{amount}}</h2>
          </div>
          <div id="ta-con">
            <table class="mdl-cell mdl-cell--12-col mdl-data-table mdl-js-data-table">
              <thead>
                <tr>
                  <th class="mdl-data-table__cell--non-numeric">Name</th>
                  <th class="mdl-data-table__cell">Quantity</th>
                  <th class="mdl-data-table__cell">Unit Price</th>
                  <th class="mdl-data-table__cell">Cost</th>
                  <th class="mdl-data-table__cell"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in items">
                  <td class="mdl-data-table__cell--non-numeric">
                    {{item.name}}
                  </td>
                  <td>
                    {{item.qty}}
                  </td>
                  <td>
                    {{item.unitPrice}}
                  </td>
                  <td>
                    {{item.unitPrice * item.qty}}
                  </td>
                  <td>
                    <div>
                      <button v-mdl class="mdl-color-text--blue-grey-900 mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect"
                       v-on:click.submit.prevent="remove(index)">
                       <i class="material-icons">
                        delete_forever
                        </i></button>
                    </div>
                  </td>
                </tr>
                <tr>
                </tr>
              </tbody>
            </table>
          </div>
      </div>
      <!-- <div class="mdl-cell mdl-cell--2-col"></div> -->
    </div>
    <div class="mdl-grid mdl-grid--no-spacing">
      <!-- <div class="mdl-cell mdl-cell--2-col"></div> -->
      <div class="mdl-cell mdl-cell--12-col mdl-card mdl-shadow--2dp">
          <div class="mdl-card__title mdl-color--grey-100 mdl-color-text--grey-600">
            <h2 class="mdl-card__title-text">Item information</h2>
          </div>
            <form class="mdl-grid center-items mdl-cell mdl-cell--12-col">
              <div id="name" class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                <input class="mdl-textfield__input" type="text"
                 id="name" placeholder="Service" v-model="name" required>
                <label class="mdl-textfield__label mdl-color-text--blue-grey-500" for="name">Name</label>
              </div>
              <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                <input class="mdl-textfield__input" type="text"
                 id="qty" placeholder="Quantity" v-model="qty" required>
                <label class="mdl-textfield__label mdl-color-text--blue-grey-500" for="qty">Quantity</label>
              </div>
              <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone  mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                <input class="mdl-textfield__input" type="text"
                 id="unitPrice" placeholder="Unit Price" v-model="unitPrice" required>
                <label class="mdl-textfield__label mdl-color-text--blue-grey-500" for="unitPrice">Unit Price</label>
              </div>
              <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                <input class="mdl-textfield__input" type="text"
                 id="cost" placeholder="Cost" :value="cost()" disabled required>
                <label class="mdl-textfield__label mdl-color-text--blue-grey-500" for="cost">Cost</label>
              </div>
            </form>
          <div class="mdl-card__actions mdl-card--border">
            <button class="mdl-color-text--blue-grey-900 mdl-cell mdl-cell--12-col mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect"
              v-mdl v-on:click.submit.prevent="addItem">
              <i class="material-icons">
                add_shopping_cart
              </i> Add Item
            </button>
          </div>
      </div>
      <!-- <div class="mdl-cell mdl-cell--2-col"></div> -->
    </div>
  </div>
</template>
<script>
// require('material-design-lite')
export default {
  name: 'add-item',
  data () {
    return {
      amount: 0,
      name: null,
      qty: null,
      unitPrice: null,
      items: []
    }
  },
  methods: {
    cost () {
      return this.qty * this.unitPrice
    },
    addItem () {
      this.items.push({name: this.name, qty: this.qty, unitPrice: this.unitPrice})
      this.total()
      this.name = null
      this.qty = null
      this.unitPrice = null
      this.complete()
    },
    remove (index) {
      this.items.splice(index, 1)
      this.total()
    },
    total () {
      this.amount = this.items.reduce(function (accumulator, item) {
        return accumulator + (Math.trunc(item.qty) * Math.trunc(item.unitPrice))
      }, 0)
    },
    complete (event) {
      this.$emit('childToParent', this.items)
    }

  },
  created () {
    this.$nextTick(() => {
      window.componentHandler.upgradeDom()
      window.componentHandler.upgradeAllRegistered()
    })
  }
}
</script>

<style scoped>

/*
h1 {
  font-size: 30px;
  margin: 15px 0;
}

.input {
  height: 30px;
}

p {
  margin-bottom: 20px;
}

.contact--section {
  background-color: white;
  padding: 20px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.05);
  .__name {
    font-size: 30px;
  }
}

table {
  border: 2px solid #42b983;
  border-radius: 3px;
  background-color: #fff;
}

th {
  background-color: #42b983;
  color: rgba(255, 255, 255, 0.66);
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

td {
  background-color: #f9f9f9;
}

td,
th {
  min-width: 120px;
  padding: 10px 20px;
} */
/* table{
  width: 100%;
  overflow-x: auto;
}
.mdl-textfield{
  width: 50%
}*/
/* #name{
  min-width: 200px;
} */
/* .mdl-textfield{
  width: 50%;
  min-width: 100px;
} */
#ta-con{
  overflow-x: scroll;
}
.mdl-cell.mdl-textfield{
  margin: 8px;
}

</style>



// WEBPACK FOOTER //
// src/components/AddItem.vue